import React, { useEffect, useState } from 'react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import Providers from './Providers';
import { appRoutes } from '../router';

const Routes: React.FC = () => {
  const routing = useRoutes(appRoutes);
  return routing;
};

function withProviders(Component: any) {
  return function (props: any) {
    return (
      <Providers>
        <Component {...props} />
      </Providers>
    );
  };
}

export default withProviders(function App() {
  const [isFramed, setIsFramed] = useState(() => {
    return window.top !== null && window.self !== window.top;
  });

  useEffect(() => {
    if (isFramed) {
      const root = document.getElementById('root');
      if (root) {
        root.style.display = 'none';
      }
      const overlay = document.createElement('div');
      overlay.id = 'frame-block-overlay';
      overlay.innerHTML = `
        <div style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: white;
          z-index: 999999;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-family: Arial, sans-serif;
          text-align: center;
          padding: 20px;
        ">
          <h1 style="color: #d32f2f; font-size: 2rem; margin-bottom: 1rem;">Access Restricted</h1>
          <p style="font-size: 1.1rem; margin-bottom: 2rem; max-width: 500px;">
            For security reasons, this application cannot be loaded within an iframe or embedded content.
          </p>
          <button onclick="window.open(window.location.href, '_blank')" 
            style="
              padding: 12px 24px;
              background: #1976d2;
              color: white;
              border: none;
              border-radius: 6px;
              cursor: pointer;
              font-size: 1rem;
              margin: 5px;
            ">
            Open in New Tab
          </button>
        </div>
      `;
      document.body.appendChild(overlay);
    }
  }, [isFramed]);
  if (isFramed) {
    return null;
  }

  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
});